import clsx from 'clsx';
import type * as React from 'react';

import type { User } from '@gitbook/api-client';

import { UserAvatar } from './UserAvatar';
import { UserDisplayName } from './UserDisplayName';

/**
 * Display a user's avatar and display name.
 */
export function UserOverview(props: {
    user: User | null;
    details?: React.ReactNode;
    className?: string;
}) {
    return (
        <div className={clsx('flex items-center gap-2', props.className)}>
            <UserAvatar user={props.user} size="md" tooltip={false} />
            <div className="flex flex-col">
                <div>
                    <UserDisplayName user={props.user} />
                </div>
                {props.details ? (
                    <div className="text-muted text-ui-small">{props.details}</div>
                ) : null}
            </div>
        </div>
    );
}
